import {
    RAW_MESSAGE_VIEW_OPEN_MODAL
} from 'Redux/actionTypes';

export const rawMessageViewOpenModal = (open, data, title, isHtml, html) => ({
    type: RAW_MESSAGE_VIEW_OPEN_MODAL,
    payload: { open, data, title, isHtml, html }
})